import { AiOutlineCheck, AiOutlineCopy, AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { OrderIcon } from '../../../../../../assets/svg/order';
import { Card } from '../../../../../../components/card/card';
import { IconButton } from '../../../../../../components/icon-button/icon-button';
import { Loader } from '../../../../../../components/loader/loader';
import { Slider } from '../../../../../../components/slider/slider';
import { DeleteModal } from '../../../../../../features/delete-modal/delete-modal';
import { HasAccess, HasAccessProps } from '../../../../../../features/has-access/has-access';
import { SortableItem } from '../../../../../../features/sorter/sortable-item';
import { Sorter } from '../../../../../../features/sorter/sorter';
import { isMobile } from '../../../../../../helpers/devices';
import { useManagerStore } from '../../../../../../store/use-manager-store';
import { MenuInformerCopyMenuModal } from './menu-informer-copy-menu-modal/menu-informer-copy-menu-modal';
import { MenuInformerCreateMenuModal } from './menu-informer-create-menu-modal/menu-informer-create-menu-modal';
import s from './menu-informer-slider.module.css';
import { useMenuInformerSlider } from './use-menu-informer-slider';

export const MenuInformerSlider = () => {
  const {
    t,
    getLocale,
    menuList,
    createMenuModal,
    menuId,
    copyMenuModal,
    isRenderSlider,
    deleteMenu,
    setMenuListOrder,
    addQueryParams,
    isLoading,
  } = useMenuInformerSlider();
  const { hasAccess } = useManagerStore();
  const isNotAllowed = !hasAccess('menu', ['write']);
  const hasAccessProps: HasAccessProps = { service: 'menu', permissions: ['write'] };

  return (
    <div className={s.feature}>
      {isLoading && <Loader />}
      <HasAccess {...hasAccessProps}>
        {createMenuModal.isOpen && (
          <MenuInformerCreateMenuModal onClose={() => createMenuModal.handleCloseModal(['id'])} />
        )}

        {copyMenuModal.isOpen && (
          <MenuInformerCopyMenuModal onClose={() => copyMenuModal.handleCloseModal(['copyMenu'])} />
        )}

        <DeleteModal onSubmit={deleteMenu} prefix="menu" />
      </HasAccess>

      {isRenderSlider && (
        <Card className={s.container}>
          <h3>{t('Меню')}</h3>

          <div className={s.row}>
            <Sorter
              itemIds={menuList.map((item) => item.id)}
              onSort={(e) => setMenuListOrder(e.map(String))}
              axis="x"
              isDisabled={isNotAllowed}
            >
              <Slider
                desktopSwipe={false}
                perSlide={4}
                count={menuList.length}
                responsive={{
                  1260: {
                    perSlide: 3,
                  },
                  840: {
                    perSlide: 2,
                  },
                  420: {
                    perSlide: 1,
                  },
                }}
              >
                {menuList.map((item, index) => {
                  const imgSrc = item.images?.main?.normal || item.images?.main?.thumbnail;
                  const isSelected = menuId === item.id;
                  const menuName = getLocale(item.name);
                  const imgFallback = getLocale(item.name)
                    .split(' ')
                    .filter(Boolean)
                    .map((word) => word[0].toUpperCase())
                    .join('');

                  return (
                    <SortableItem
                      key={item.id}
                      sortableArgs={{
                        id: item.id,
                        data: {
                          index,
                        },
                      }}
                      isDisabled={isNotAllowed}
                      withSortIcon={false}
                    >
                      <div key={item.id} onClick={() => addQueryParams({ menuId: item.id })}>
                        <div className={s['menu-item']}>
                          <div className={s['img-wrapper']}>
                            {imgSrc ? (
                              <img src={imgSrc} className={s.img} />
                            ) : (
                              <span className={s.fallback}>{imgFallback}</span>
                            )}
                            {isSelected && (
                              <div className={s['icon-wrapper']}>
                                <AiOutlineCheck className={s.icon} />
                              </div>
                            )}
                            {!isMobile() && !isNotAllowed && (
                              <IconButton variant="ghost" className={s.order} size="sm">
                                <OrderIcon />
                              </IconButton>
                            )}
                          </div>

                          <div className={s.bottom}>
                            <span className={s.name}>{menuName}</span>

                            <HasAccess {...hasAccessProps}>
                              <div className={s.actions}>
                                <IconButton
                                  tooltip={t('Копировать меню')}
                                  size="sm"
                                  variant="secondary"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    copyMenuModal.handleOpenModal({
                                      copyMenu: JSON.stringify(item),
                                    });
                                  }}
                                >
                                  <AiOutlineCopy />
                                </IconButton>

                                <IconButton
                                  tooltip={t('Редактировать')}
                                  size="sm"
                                  variant="secondary"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    createMenuModal.handleOpenModal({ id: item.id });
                                  }}
                                >
                                  <AiOutlineEdit />
                                </IconButton>

                                <IconButton
                                  tooltip={t('Удалить')}
                                  size="sm"
                                  variant="secondary"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    addQueryParams({
                                      deleteId: item.id,
                                      deleteName: getLocale(item.name),
                                      deletePrefix: 'menu',
                                    });
                                  }}
                                >
                                  <AiOutlineDelete />
                                </IconButton>
                              </div>
                            </HasAccess>
                          </div>
                        </div>
                      </div>
                    </SortableItem>
                  );
                })}
              </Slider>
            </Sorter>
          </div>
        </Card>
      )}
    </div>
  );
};
